import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { PricingComponent } from './pricing/pricing.component';
import { HomeComponent } from './home/home.component';
import { BannerEditorComponent } from './banner-editor/banner-editor.component';
import { LoginComponent } from './login/login.component';
import { CasoUsoComponent } from './caso-uso/caso-uso.component';
import { PrivacyComponent } from './privacy/privacy.component';
import { SupportComponent } from './support/support.component';
import { ImagesComponent } from './images/images.component';
import { AuthGuard } from './auth.guard';
import { BannerEditorUnsavedChangesGuard } from './banner-editor-unsaved-changes.guard';

const routes: Routes = [
  { 
    path: '', 
    redirectTo: '/home', 
    pathMatch: 'full'
  },
  { 
    path: 'login', 
    component: LoginComponent
  },
  { 
    path: 'home', 
    component: HomeComponent
  },
  { 
    path: 'pricing', 
    component: PricingComponent
  },
  { 
    path: 'banner-editor', 
    component: BannerEditorComponent,
    canActivate: [AuthGuard],
    canDeactivate: [BannerEditorUnsavedChangesGuard]
  },
  { 
    path: 'casos-uso', 
    component: CasoUsoComponent
  },
  { 
    path: 'privacy', 
    component: PrivacyComponent
  },
  { 
    path: 'support', 
    component: SupportComponent
  },
  { 
    path: 'images', 
    component: ImagesComponent,
    canActivate: [AuthGuard]
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabledBlocking'
  })],
  exports: [RouterModule]
})
export class AppRoutingModule { }
